












import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { InfoService } from '../../services/api/info'

@Component
export default class PlainHeader extends Vue {
  @Prop()
  title: string

  @Prop({ default: '' })
  prevUrl: string

  @Prop({ default: '/' })
  topUrl: string

  versioning: string | null = null

  shouldDisplayVersioning: boolean = false

  async created() {
    // TODO: Use Vuex store
    const result = await InfoService.versioning()

    if (result.isLeft()) {
      return
    }

    this.versioning = _.get(result.value, 'fullText')
    this.shouldDisplayVersioning = _.get(result.value, 'display')
  }
}
